export var DocsBlockItemPropertyOptionRenderingStyle;
(function (DocsBlockItemPropertyOptionRenderingStyle) {
    /** Option will be rendered as a segmented control */
    DocsBlockItemPropertyOptionRenderingStyle["segmentedControl"] = "SegmentedControl";
    /** Option will be rendered as a toggle button */
    DocsBlockItemPropertyOptionRenderingStyle["toggleButton"] = "ToggleButton";
    /** Option will be rendered as a select */
    DocsBlockItemPropertyOptionRenderingStyle["select"] = "Select";
    /** Option will be rendered as a checkbox */
    DocsBlockItemPropertyOptionRenderingStyle["checkbox"] = "Checkbox";
})(DocsBlockItemPropertyOptionRenderingStyle || (DocsBlockItemPropertyOptionRenderingStyle = {}));
